'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var calendarDateVariants = {
    available: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    active: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    current: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    cursor: pointer;\n  "], ["\n    color: ", ";\n    cursor: pointer;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    inactive: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    cursor: not-allowed;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    cursor: not-allowed;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    unavailable: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    text-decoration-line: line-through;\n    cursor: not-allowed;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    text-decoration-line: line-through;\n    cursor: not-allowed;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    adjacentMonth: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
};
var CalendarDateStyled = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  font-size: 14px;\n  height: ", ";\n  width: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ", ";\n  overflow: hidden;\n  word-break: break-word;\n  text-align: center;\n\n  ", "\n"], ["\n  font-size: 14px;\n  height: ", ";\n  width: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ", ";\n  overflow: hidden;\n  word-break: break-word;\n  text-align: center;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, size = _a.size;
    return theme.components.calendar.sizes[size].cell.px;
}, function (_a) {
    var theme = _a.theme, size = _a.size;
    return theme.components.calendar.sizes[size].cell.px;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedMediumGrey;
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'available' : _b;
    return calendarDateVariants[variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.CalendarDateStyled = CalendarDateStyled;
